import React from "react";
import { cn } from "@/libs/utils";

interface LinkWrapperProps {
  href: string;
  target: "_self" | "_blank";
  className?: string;
  children: React.ReactNode;
}

export const LinkWrapper = ({
  href,
  target,
  className,
  children,
}: LinkWrapperProps) => (
  <a href={href} target={target} className={cn("w-full", className)}>
    {children}
  </a>
);
